"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fast_copy_1 = __importDefault(require("fast-copy"));
const utils_1 = require("../utils");
const fetchModel_1 = __importDefault(require("../utils/fetchModel"));
const getModelListFromCache_1 = __importDefault(require("../utils/getModelListFromCache"));
class GraphandQuery {
    constructor(Model, q) {
        this._model = Model;
        Object.defineProperty(this, "_model", { enumerable: false });
        if (q) {
            const { query } = q, fields = __rest(q, ["query"]);
            Object.assign(this, fields);
            if (q.query) {
                this.query = (0, utils_1.parseQuery)(q.query);
            }
        }
    }
    getCachedList() {
        return (0, getModelListFromCache_1.default)(this._model, this);
    }
    clone() {
        const { ids, query, sort, populate, page, pageSize } = this;
        const _clone = new GraphandQuery(this._model);
        Object.assign(_clone, (0, fast_copy_1.default)({ ids, query, sort, populate, page, pageSize }));
        return _clone;
    }
    async execute(opts) {
        if (opts === null || opts === void 0 ? void 0 : opts.populate) {
            this.populate = opts === null || opts === void 0 ? void 0 : opts.populate;
        }
        const query = this.isMergeable() ? this.clone() : this;
        return (0, fetchModel_1.default)(this._model, query, opts);
    }
    isMergeable() {
        const queryKeys = Object.keys(this).filter((key) => this[key] && ["query", "ids", "pageSize", "page", "populate"].includes(key));
        return queryKeys.includes("ids") && queryKeys.length === 1;
    }
}
exports.default = GraphandQuery;
